import React, { useMemo } from 'react';
import _ from 'lodash';
import { storyblokEditable } from 'gatsby-source-storyblok';
import type { ISbStoryData } from '@storyblok/js';
// eslint-disable-next-line max-len
import type {
  ProductSpecificationColorList as IProductSpecificationColorList,
  ProductComparisonProductVariant,
} from '../../../../.storyblok/types/255103/storyblok-components';
import { useRootState } from '../../../context/root-state.context';

interface ProductComparisonProductSpecificationListProps {
  blok: IProductSpecificationColorList;
}

const ProductSpecificationColorList = ({ blok }: ProductComparisonProductSpecificationListProps) => {
  const { productVariantStories } = useRootState();

  const productVariantStoriesFiltered = useMemo(() => {
    return productVariantStories.filter((story) => blok.productVariants.includes(story.uuid));
  }, [blok, productVariantStories]);

  const productVariants: ProductComparisonProductVariant[] = useMemo(() => {
    return productVariantStoriesFiltered
      .map((productVariantStory: ISbStoryData<ProductComparisonProductVariant>) => productVariantStory.content)
      .sort(
        (a: ProductComparisonProductVariant, b: ProductComparisonProductVariant) => Number(a.order) - Number(b.order),
      );
  }, [productVariantStoriesFiltered]);

  return (
    <div className="w-full flex flex-col flex-nowrap gap-y-2" {...storyblokEditable(blok)}>
      {productVariants.map((productVariant) => {
        return (
          <div key={productVariant.variantName} className="flex flex-row flex-nowrap items-center gap-x-2">
            {!_.isEmpty(productVariant.customColorIcon?.filename) && (
              <div
                className="w-[15px] h-[15px] rounded-[50%]"
                style={{ backgroundImage: `url(${productVariant.customColorIcon?.filename})` }}
              />
            )}

            {_.isEmpty(productVariant.customColorIcon?.filename) &&
              !_.isUndefined(_.get(productVariant, 'color.color')) && (
                <div
                  className="w-[15px] h-[15px] rounded-[50%]"
                  // @ts-expect-error color field is a SB plugin that is not properly typed
                  style={{ backgroundColor: productVariant.color?.color ?? '' }}
                />
              )}

            <p className="typography-body-s sm:typography-body-m !text-navy-600 !font-utopiaStdCaption m-0">
              {productVariant.variantName}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default ProductSpecificationColorList;
